import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const LabeledOptionBlock = styled.div`
  &&&&& {
    display: flex;
  }
`;

export const OptionLabel = styled.span`
  &&&&& {
    width: 80px;
    flex-shrink: 0;
    align-self: center;
    color: ${globals.MOON_800};
  }
`;

export const Option = styled.div`
  &&&&& {
    flex-grow: 1;
    padding: 4px;
    justify-content: center;
    align-items: center;
  }
`;
